module.exports = __webpack_public_path__ + "static/img/header_logo.a8f314d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publick/header_logo.png
// module id = Wokn
// module chunks = 29